module.exports = __webpack_public_path__ + "yellowIcon.webp";